"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialsWrapper = void 0;
var React = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _SocialButton = require("../SocialButton");
var _SocialExpandButton = require("../SocialExpandButton");
var styles = _interopRequireWildcard(require("./SocialsWrapper.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const SocialsWrapper = props => {
  const {
    isExpanded,
    onClick,
    list,
    expand,
    error,
    frameless
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)(styles['container'], {
      [styles['frameless']]: frameless
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['buttons-container']
  }, /*#__PURE__*/React.createElement("ul", {
    className: (0, _classnames.default)(styles['buttons'], styles['horizontal-scroll'])
  }, list.map(socialType => /*#__PURE__*/React.createElement("li", {
    key: `social_button-${socialType}`,
    className: styles['buttons-item']
  }, /*#__PURE__*/React.createElement(_SocialButton.SocialButton, {
    type: socialType,
    onClick: onClick
  }))), !isExpanded && /*#__PURE__*/React.createElement("li", {
    className: styles['buttons-item']
  }, /*#__PURE__*/React.createElement(_SocialExpandButton.SocialExpandButton, {
    onClick: expand
  })))), error && /*#__PURE__*/React.createElement("div", {
    className: styles['error']
  }, error));
};
exports.SocialsWrapper = SocialsWrapper;